import http from "@/shared/api/http";

export async function getCartItemsByRoomId(roomId) {
  return unwrap(await http.get(`cartItem/byRoomId/${roomId}`)) ?? [];
}

export async function createCartItem(payload) {
  console.log("API createCartItem payload:", payload);
  const result = await http.post("cartItem", payload);
  console.log("API createCartItem response:", result.data);
  return unwrap(result);
}

export async function getCartItemById(id) {
  return unwrap(await http.get(`cartItem/byId/${id}`));
}

export async function updateCartItem(id, payload) {
  return unwrap(await http.put(`cartItem/${id}`, payload));
}

export async function updateCartItemDiscount(id, payload) {
  return unwrap(await http.patch(`cartItem/${id}/discount`, payload));
}

export async function deleteCartItem(id) {
  return unwrap(await http.delete(`cartItem/${id}`));
}

function unwrap(res) {
  if (!res || !res.data) return null;

  if (res.data.value !== undefined) return res.data.value;

  return res.data;
}

export async function moveCartItemToRoom(cartItemId, newRoomId) {
  const item = await getCartItemById(cartItemId);
  if (!item) throw new Error("Cart item not found");
  
  return updateCartItem(cartItemId, {
    quantity: item.quantity,
    roomId: newRoomId
  });
}

export async function removeCartItemFromRoom(cartItemId) {
  const item = await getCartItemById(cartItemId);
  if (!item) throw new Error("Cart item not found");
  
  return updateCartItem(cartItemId, {
    quantity: item.quantity,
    roomId: null
  });
}
